import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import DatePicker from "./smartComponents/datePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/sagas/multiLocation/multiLocation";
import RegionSelect from "./smartComponents/regionSelect";
import SiteSelect from "./smartComponents/siteSelect";
// import LocationSelect from "./smartComponents/locationSelect";
import RevenueTable from "./smartComponents/revenueTable";
import LeadsTable from "./smartComponents/leadsTable";
import FirstVisitsTable from "./smartComponents/firstVisitsTable";
import MembershipTable from "./smartComponents/membershipTable";
import IntroConversionTable from "./smartComponents/introConverstionsTable";
import CustomDateRanges from "./smartComponents/customDateRanges";
import { getValueInsideTag } from "../../../../utils/formatters";

const minTableHeight = 600;

export class MultiLocationModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersDirty: false,
      height: minTableHeight
    };
  }

  checkForRender(nextProps) {
    return Boolean(
      (this.props !== nextProps) &
        !this.props.isLoading &
        !this.props.tablesLoading &
        (this.props.allRevenueData.length !== 0) &
        (this.props.leadsData.length !== 0)
    );
  }

  componentDidUpdate(nextProps) {
    if (this.checkForRender(nextProps)) {
      this.setState({
        height:
          (this.props.allRevenueData.length + this.props.leadsData.length) * 43 + minTableHeight
      });
    }
  }

  resetData = () => {
    this.props.fetchTableData(this.props.userParams);
    this.setState({
      filtersDirty: false
    });
  };

  componentDidMount() {
    this.initFetchData();
  }

  initFetchData() {
    this.props.fetchTableData(this.props.userParams);
  }

  updateTables = () => {
    this.props.updateTables();
    this.setState({
      height: minTableHeight
    });
  };

  canRenderUpdateButton = () => {
    if (
      this.props.filtersDirty &
      !this.props.isLoading &
      (this.props.selectedRegions.length > 0) &
      (this.props.selectedSites.length > 0) &
      (this.props.selectedLocations.length > 0) &
      (this.props.selectedRequestDates.startDate !== "Invalid date") &
      (this.props.selectedRequestDates.endDate !== "Invalid date")
    ) {
      return true;
    }
  };

  getAveragesInsideTag = (data, index) => {
    let val = 0;
    let length = data.length;

    data.map((item) => {
      val = val + getValueInsideTag(item[index]);
    });

    return (parseFloat(val) / length).toFixed(1);
  };

  getAveragesInsideTags = (data, indexes) => {
    let val = 0;
    let length = data.length;

    data.map((item) => {
      indexes.map((index) => {
        val = val + getValueInsideTag(item[index]);
      });
    });

    return (parseFloat(val) / length).toFixed(1);
  };

  getAverages = (data, indexes) => {
    let val = 0;
    let length = data.length;

    data.map((item) => {
      indexes.map((index) => {
        val = val + parseFloat(item[index]);
      });
    });

    return (parseFloat(val) / length).toFixed(1);
  };

  getTotalInTag = (value, link = "") => {
    return link ? (
      <a href={link} target="_blank" rel="noreferrer">
        {value}
      </a>
    ) : (
      <span>{value}</span>
    );
  };

  renderTables = () => {
    let { moduleInfo, revenue_mtd, revenue_mtd_link, revenue_mom } = this.props.allRevenue;
    let { new_members_mtd, new_members_mtd_link, new_members_mom } = this.props.memberships;
    let { profiles_mtd, profiles_mtd_link, profiles_mom } = this.props.leads;
    let { first_visits_mtd, first_visits_mtd_link, first_visits_mom } = this.props.firstVisits;
    let {
      profiles_conversion_total,
      profiles_conversion_total_mtd_link,
      converted_leads_mom,
      fvn_total,
      fvn_total_mtd_link,
      converted_fv_mom
    } = this.props.introConversions;

    return (
      <div className="spenga-multi-location">
        <div className="table-wrapper-top">
          <div className="table-top">
            <div className="table-top-wrapper">
              <div className="title">
                <h2>
                  {moduleInfo.title}:{" "}
                  <span className="metrics">
                    <span className="total">
                      {this.getTotalInTag(revenue_mtd, revenue_mtd_link)}
                      <span
                        className={`percent ${
                          revenue_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {revenue_mom}
                      </span>
                    </span>
                  </span>
                </h2>
                <div className="metrics">
                  <p className="averages">&nbsp;</p>
                </div>
              </div>
            </div>
            <RevenueTable />
          </div>
          <div className="table-top">
            <div className="table-top-wrapper">
              <div className="title">
                <h2>
                  {this.props.memberships.moduleInfo.title}:{" "}
                  <span className="metrics">
                    <span className="total">
                      {this.getTotalInTag(new_members_mtd, new_members_mtd_link)}
                      <span className="percent">(new)</span>
                      <span
                        className={`percent ${
                          new_members_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {new_members_mom}
                      </span>
                    </span>
                  </span>
                </h2>
                <div className="metrics">
                  <div className="left">
                    <p className="averages">
                      Network Average New:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [1])}</span>
                    </p>
                  </div>
                  <div className="right">
                    <p className="averages">
                      Network Average Cancel:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [2])}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <MembershipTable />
          </div>
        </div>
        <div className="table-wrapper-bottom">
          <div className="table-bottom">
            <div className="table-bottom-wrapper">
              <div className="title">
                <h2>
                  {this.props.leads.moduleInfo.title}:{" "}
                  <span className="metrics">
                    <span className="total">
                      {this.getTotalInTag(profiles_mtd, profiles_mtd_link)}
                      <span
                        className={`percent ${
                          profiles_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {profiles_mom}
                      </span>
                    </span>
                  </span>
                </h2>
                <div className="metrics">
                  <div className="left">
                    <p className="averages">
                      Network Average:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [4])}</span>
                    </p>
                  </div>
                  <div className="right">
                    <p className="averages">&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
            <LeadsTable />
          </div>
          <div className="table-bottom">
            <div className="table-bottom-wrapper">
              <div className="title">
                <h2>
                  {this.props.firstVisits.moduleInfo.title}:{" "}
                  <span className="metrics">
                    <span className="total">
                      {this.getTotalInTag(first_visits_mtd, "")}
                      {/*{this.getTotalInTag(first_visits_mtd, first_visits_mtd_link)}*/}
                      <span
                        className={`percent ${
                          first_visits_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {first_visits_mom}
                      </span>
                    </span>
                  </span>
                </h2>
                <div className="metrics">
                  <div className="left">
                    <p className="averages">
                      Network Average:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [5])}</span>
                    </p>
                  </div>
                  <div className="right">
                    <p className="averages">&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
            <FirstVisitsTable />
          </div>
          <div className="table-bottom last">
            <div className="table-bottom-wrapper">
              <div className="title">
                <h2 style={{ whiteSpace: "nowrap" }}>
                  {this.props.introConversions.moduleInfo.title}:{" "}
                  <span className="metrics">
                    <span className="total">
                      {this.getTotalInTag(profiles_conversion_total, "")}
                      {/*{this.getTotalInTag(profiles_conversion_total, profiles_conversion_total_mtd_link)}*/}
                      <span className="percent">(L-FV)</span>
                      <span
                        className={`percent ${
                          converted_leads_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {converted_leads_mom}
                      </span>
                    </span>
                    <span className="conversions-separator">|</span>
                    <span className="total">
                      {this.getTotalInTag(fvn_total, "")}
                      {/*{this.getTotalInTag(fvn_total, fvn_total_mtd_link)}*/}
                      <span className="percent">(FV-P)</span>
                      <span
                        className={`percent ${
                          converted_fv_mom.indexOf("-") > -1 ? "negative" : "positive"
                        }`}
                      >
                        {converted_fv_mom}
                      </span>
                    </span>
                  </span>
                </h2>

                <div className="metrics">
                  <div className="left">
                    <p className="averages">
                      Network Average L-FV:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [6])}%</span>
                    </p>
                  </div>
                  <div className="right">
                    <p className="averages">
                      Network Average FV-P:{" "}
                      <span>{this.getAverages(this.props.averages.tableInfo.data, [7])}%</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <IntroConversionTable />
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="multi-location-module spenga">
        <SectionToggle
          title="HQ Dash"
          customClass="multi-location-comparison"
          maxHeight="initial"
          hideToggle
          content={
            this.props.isLoading ? (
              <LoadingAnimation text="Gathering the latest data across all locations..." />
            ) : (
              <div>
                {!this.props.filtersLoading && (
                  <div className="edit-selections-bar">
                    <div className="select-box">
                      <p>Region</p>
                      <RegionSelect />
                    </div>
                    <div className="select-box">
                      <p>Location</p>
                      {this.props.siteFiltersLoading ? (
                        <LoadingAnimation uiLoader />
                      ) : (
                        <SiteSelect />
                      )}
                    </div>
                    <div className="select-box" style={{ width: "355px" }}>
                      <p className="offers-title">Date Range</p>
                      {!this.state.filtersDirty && <CustomDateRanges />}
                    </div>
                    <div className="date-select-box multi">
                      <p>Date</p>
                      {!this.state.filtersDirty && <DatePicker />}
                    </div>
                    <div className="action-buttons">
                      {this.canRenderUpdateButton() && (
                        <button className="submit" onClick={() => this.updateTables()}>
                          Update
                        </button>
                      )}
                      {this.props.filtersDirty && !this.props.isLoading && (
                        <button className="submit reset" onClick={() => this.initFetchData()}>
                          Reset
                        </button>
                      )}
                    </div>
                  </div>
                )}
                {this.props.tablesLoading ? (
                  <LoadingAnimation text="Updating tables..." />
                ) : (
                  this.renderTables()
                )}
              </div>
            )
          }
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.multiLocation.isLoading,
    filtersDirty: state.multiLocation.filtersDirty,
    selectedRequestDates: state.multiLocation.selectedRequestDates,
    selectedRegions: state.multiLocation.selectedRegions,
    selectedSites: state.multiLocation.selectedSites,
    selectedLocations: state.multiLocation.selectedLocations,
    tablesLoading: state.multiLocation.tablesLoading,
    memberships: state.multiLocation.memberships,
    introConversions: state.multiLocation.introConversions,
    introConversionsData: state.multiLocation.introConversions.tableInfo.data,
    allRevenue: state.multiLocation.allRevenue,
    allRevenueData: state.multiLocation.allRevenue.tableInfo.data,
    leads: state.multiLocation.leads,
    leadsData: state.multiLocation.leads.tableInfo.data,
    firstVisits: state.multiLocation.firstVisits,
    firstVisitsData: state.multiLocation.firstVisits.tableInfo.data,
    filtersLoading: state.multiLocation.filtersLoading,
    averages: state.multiLocation.averages,
    siteFiltersLoading: state.multiLocation.siteFiltersLoading,
    locationFiltersLoading: state.multiLocation.locationFiltersLoading
  }),
  {
    fetchTableData: actionCreators.fetchTableData,
    updateTables: actionCreators.requestNewTableData
  }
)(MultiLocationModule);

MultiLocationModule.propTypes = {
  fetchTableData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  tablesLoading: PropTypes.bool,
  userParams: PropTypes.object,
  filtersDirty: PropTypes.bool,
  selectedRequestDates: PropTypes.object,
  updateTables: PropTypes.func,
  selectedRegions: PropTypes.any,
  selectedSites: PropTypes.any,
  selectedLocations: PropTypes.any,
  filtersLoading: PropTypes.bool,
  siteFiltersLoading: PropTypes.bool,
  locationFiltersLoading: PropTypes.bool,
  allRevenue: PropTypes.object,
  allRevenueData: PropTypes.array,
  leadsData: PropTypes.array,
  leads: PropTypes.object,
  firstVisits: PropTypes.object,
  memberships: PropTypes.object,
  introConversions: PropTypes.object,
  firstVisitsData: PropTypes.array,
  introConversionsData: PropTypes.array,
  averages: PropTypes.object
};
